import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const [handle, setHandle] = useState('');
  const { login, loading, error, isAuthenticated } = useAuth();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const returnUrl = queryParams.get('returnUrl') || '/altifier';

  useEffect(() => {
    if (isAuthenticated) {
      setTimeout(() => {
        window.location.replace(returnUrl);
      }, 100);
    }
  }, [isAuthenticated, returnUrl]);

  const handleInputChange = (event) => {
    setHandle(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      localStorage.setItem('auth_redirect_url', returnUrl);
      await login(handle || null, returnUrl);
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  if (isAuthenticated) {
    return (
      <div className="login-page">
        <div className="login-content">
          <p>Already logged in. Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-content">
        <h1>Login to Altifier</h1>
        <p>Enter your Bluesky or ATProto handle</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={handle}
            onChange={handleInputChange}
            placeholder="username.bsky.social"
            disabled={loading}
          />
          {loading && <p>Processing...</p>}
          {error && <p>Login failed: {error}</p>}
          <button type="submit" disabled={loading || isAuthenticated}>
            {loading ? 'Processing...' : 'Login with Bluesky'}
          </button>
        </form>
        <p>We use official Bluesky/ATProto OAuth to securely process your login.</p>
      </div>
    </div>
  );
};

export default Login;
